import * as React from "react";
const SvgArgument = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "none", viewBox: "0 0 14 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.2, d: "M5.048 1.408a2.76 2.76 0 0 1 3.904 0l3.64 3.64a2.76 2.76 0 0 1 0 3.904l-3.64 3.64a2.76 2.76 0 0 1-3.904 0l-3.64-3.64a2.76 2.76 0 0 1 0-3.904z" }), /* @__PURE__ */ React.createElement("rect", { width: 2, height: 2, x: 6, y: 6, fill: "currentColor", rx: 1 }));
export {
  SvgArgument as default
};
//# sourceMappingURL=argument.js.map
